import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataTransaction(params) {
	return client.get("api/ecommerce/transaction/data", {
		params: params,
	});
}

function getDataTransactionCancel(params) {
	return client.get("api/ecommerce/transaction/data-cancel", {
		params: params,
	});
}

function exportTransaction(params) {
	return client.get("api/ecommerce/transaction/export", {
		params: params,
	});
}

function getDetailTransaction (params) {
	return client.get("api/ecommerce/transaction/detail", {
		params: params,
	});
}

function getStatusListTransaction (params) {
	return client.get("api/ecommerce/transaction/status-list", {
		params: params,
	});
}

function getDataBankTransfer(params) {
	return client.get("api/ecommerce/transfer-bank/data", {
		params: params,
	});
}

function getDataBankTransferCancel(params) {
	return client.get("api/ecommerce/transfer-bank/data-cancel", {
		params: params,
	});
}

function approvalTransfer(params) {
	return client.post("api/ecommerce/transfer-bank/approval-transfer", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function cancelApprovalTransfer(params) {
	return client.post("api/ecommerce/transfer-bank/cancel-approval-transfer", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function exportBankTransfer(params) {
	return client.get("api/ecommerce/transfer-bank/export", {
		params: params,
	});
}

function exportBankTransferCancel(params) {
	return client.get("api/ecommerce/transfer-bank/export-cancel", {
		params: params,
	});
}

function getTransactionCash(params) {
	return client.get("api/ecommerce/transaction/data-cash", {
		params: params,
	});
}

function exportTransactionCash(params) {
	return client.get("api/ecommerce/transaction/export-cash", {
		params: params,
	});
}

function getTransactionVA(params) {
	return client.get("api/ecommerce/transaction/data-va", {
		params: params,
	});
}

function exportTransactionVA(params) {
	return client.get("api/ecommerce/transaction/export-va", {
		params: params,
	});
}

function sendEmailSerial(params) {
	return client.post("api/ecommerce/transaction/resend_email", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function checkTransaction(params) {
	return client.get("api/ecommerce/transaction/check_transaction", {
		params: params,
	});
}

function cancelTransaction(params) {
	return client.post("api/ecommerce/transaction/cancel_transaction", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function exportTransactionCanceled(params) {
	return client.get("api/ecommerce/transaction/export_canceled", {
		params: params,
	});
}

export default {
	getDataTransaction,
	getDataTransactionCancel,
	exportTransaction,
	getDetailTransaction,
	getStatusListTransaction,
	getDataBankTransfer,
	getDataBankTransferCancel,
	approvalTransfer,
	cancelApprovalTransfer,
	exportBankTransfer,
	exportBankTransferCancel,
	getTransactionCash,
	exportTransactionCash,
	getTransactionVA,
	exportTransactionVA,
	sendEmailSerial,
	checkTransaction,
	cancelTransaction,
	exportTransactionCanceled,
}